(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bkf-newsletter-content"] && !Shopify.designMode) return;
  try {
    if (!window.BKFNewsletterSignupBound) {
    const updateStatus = (form, state, message) => {
      const status = form.querySelector('.bkf-newsletter__form-status');

      if (!(status instanceof HTMLElement)) return;

      status.hidden = !message;
      status.textContent = message;

      if (message) {
        status.dataset.state = state;
      } else {
        delete status.dataset.state;
      }
    };

    document.addEventListener('submit', async (event) => {
      const submittedForm = event.target;

      if (!(submittedForm instanceof HTMLFormElement)) return;
      if (!submittedForm.hasAttribute('data-bkf-newsletter-form')) return;

      event.preventDefault();

      if (submittedForm.dataset.submitting == 'true') return;
      if (!submittedForm.reportValidity()) return;

      submittedForm.dataset.submitting = 'true';
      window.ThemeFormLoading?.start(submittedForm);
      updateStatus(submittedForm, '', '');

      const submitButton = submittedForm.querySelector('button[type="submit"]');

      if (submitButton instanceof HTMLButtonElement) {
        submitButton.disabled = true;
      }

      const formData = new FormData(submittedForm);
      const payload = new URLSearchParams();

      payload.set('g', submittedForm.dataset.klaviyoListId || '');
      payload.set('$fields', '$first_name,$region,newsletter_signup_source');
      payload.set('email', String(formData.get('email') || ''));
      payload.set('$first_name', String(formData.get('$first_name') || ''));
      payload.set('$region', String(formData.get('$region') || ''));
      payload.set('newsletter_signup_source', submittedForm.dataset.klaviyoSignupSource || 'homepage');

      try {
        const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: payload.toString(),
        });

        let responseBody = null;

        try {
          responseBody = await response.json();
        } catch (error) {
          responseBody = null;
        }

        if (response.ok) {
          submittedForm.reset();

          const successRedirectUrl = submittedForm.dataset.successRedirectUrl;

          if (successRedirectUrl) {
            window.location.assign(successRedirectUrl);
            return;
          }

          updateStatus(
            submittedForm,
            'success',
            submittedForm.dataset.successMessage || 'Thanks for signing up.'
          );
          return;
        }

        let errorMessage = submittedForm.dataset.errorMessage || 'Something went wrong. Please try again.';

        if (response.status === 400) {
          errorMessage = submittedForm.dataset.existingMessage || errorMessage;
        } else if (responseBody && typeof responseBody.message == 'string' && responseBody.message) {
          errorMessage = responseBody.message;
        }

        updateStatus(submittedForm, 'error', errorMessage);
      } catch (error) {
        updateStatus(
          submittedForm,
          'error',
          submittedForm.dataset.errorMessage || 'Something went wrong. Please try again.'
        );
      } finally {
        submittedForm.dataset.submitting = 'false';
        window.ThemeFormLoading?.stop(submittedForm);

        if (submitButton instanceof HTMLButtonElement) {
          submitButton.disabled = false;
        }
      }
    });

    window.BKFNewsletterSignupBound = true;
  }
  } catch(e) { console.error(e); }
})();

})();
